module.exports = __webpack_public_path__ + "img/myposition_ss_웨인 루니.0c75222e.png";